import classNames from "classnames";

import "./loading.scss";

export type TLoadingProps = {
	size?: number;
	fixed?: boolean;
	circle?: boolean;
	absolute?: boolean;
};

export function Loading({
	size = 100,
	fixed = true,
	circle = false,
	absolute = false,
}: TLoadingProps) {
	return (
		<div
			className={classNames({
				"spinner-container-fixed": fixed,
				"spinner-container-absolute": absolute,
				circle,
			})}>
			<div
				className="spinner-box"
				style={{ width: `${size}px`, height: `${size}px` }}>
				<div
					className="three-quarter-spinner"
					style={{ width: `${size - 6}px`, height: `${size - 6}px` }}
				/>
			</div>
		</div>
	);
}
